import { motion } from 'framer-motion';
import { styled } from 'styled-components';

const Container = styled(motion.div)`
  position: relative;
  min-height: 100vh;
  height: 100vh;
  width: 100%;
  margin: 0 auto;
  padding: 2rem;

  display: flex;
  flex-direction: ${props => (props.$flexDirection ? props.$flexDirection : 'column')};
  flex-wrap: no-wrap;
  gap: ${props => (props.gap ? props.gap : props.theme.spaceLg)};

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.sm}) {
    max-width: ${props => props.theme.breakpoints.width.sm};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.md}) {
    max-width: ${props => props.theme.breakpoints.width.md};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.lg}) {
    max-width: ${props => props.theme.breakpoints.width.lg};
  }

  @media only screen and (min-width: ${props => props.theme.breakpoints.width.xl}) {
    max-width: ${props => props.theme.breakpoints.width.xl};
  }
`;

export default Container;
